import { useState } from 'react';

export function useQuestionFilters() {
  const [filters, setFilters] = useState({
    searchQuery: '',
    selectedGroup: '',
    selectedStatus: '',
  });

  function updateFilters(newFilters) {
    setFilters(newFilters);
  }

  function clearFilters() {
    setFilters({
      searchQuery: '',
      selectedGroup: '',
      selectedStatus: '',
    });
  }

  const hasActiveFilters = Boolean(
    filters.searchQuery || filters.selectedGroup || filters.selectedStatus,
  );

  return {
    filters,
    updateFilters,
    clearFilters,
    hasActiveFilters,
  };
}
